import React, { Component } from "react";

import { Helmet } from "react-helmet";
import Rellax from "rellax";
import BlogItem from "components/BlogGrid/BlogItem";
import { withRouter } from "react-router";

import Hero from "components/PageHero/Hero";
import TextBlock from "components/TextBlock/TextBlock";
import { I18n } from "react-i18next";

class BlogSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogs: [],
      blogdetail: {},
      loading: true,
    };
  }
  componentDidUpdate() {
    setTimeout(function () {
      window.scrollTo(0, "#pageWrapper");
    }, 100);
  }

  componentDidMount() {
    new Rellax(".parallax-logo", {
      speed: 4,
      center: false,
      round: true,
      vertical: true,
      horizontal: false,
    });

    this.reloadBlogs();
  }
  UNSAFE_componentWillReceiveProps() {
    this.reloadBlogs();
  }

  async reloadBlogs() {
    const slug = window.location.pathname.substring(6);

    const overview = await fetch(
      `${process.env.REACT_APP_API_URL}fpgblog/v1/detail/${slug}`
    );
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}fpgblog/v1/random`
    );
    let blogdetail = await overview.json();
    let blogs = await res.json();
    this.setState({ blogs: blogs, blogdetail: blogdetail });
  }

  renderBlog(blog, i) {
    return <BlogItem className="blogGrid-blogItem" data={blog} />;
  }

  render() {
    const { blogs, blogdetail } = this.state;
    return [
      <I18n>
        {(t, { i18n }) => (
          <Helmet key="head">
            <meta charSet="utf-8" />
            <title>
              Innovatie | Forever Plants | Ontdek waar FPG voor staat
            </title>
            <meta property="og:image" content={blogdetail.thumbnail} />
            <meta
              name="description"
              content="We vertellen graag over onszelf. Nog liever vertellen we over waar Forever Plants Group voor staat en wat we willen bereiken met de planten die we grootbrengen. Lees hier alles over het groener maken van woonkamers, bedrijven, levens en uiteindelijk ook de hele wereld. Ambitieus? Zeker. Onmogelijk? Niet als jij ook meehelpt."
            />
            <meta
              property="og:description"
              content="We vertellen graag over onszelf. Nog liever vertellen we over waar Forever Plants Group voor staat en wat we willen bereiken met de planten die we grootbrengen. Lees hier alles over het groener maken van woonkamers, bedrijven, levens en uiteindelijk ook de hele wereld. Ambitieus? Zeker. Onmogelijk? Niet als jij ook meehelpt."
            />
          </Helmet>
        )}
      </I18n>,
      <span className="parallax-logo" key="logo" />,
      <I18n>
        {(t, { i18n }) => (
          <main id="pageWrapper" key="content">
            <div className="wrapper-hero-video">
              <Hero imageSrc={blogdetail.thumbnail} />
            </div>
            <div className="wrapper">
              <span className="blog-credits">
                {blogdetail.date} - {blogdetail.author} Leestijd 5 min
              </span>
              <div class="textblock text-blog">
                <h2>{blogdetail.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: blogdetail.text }} />
              </div>
              {/* <TextBlock extraClasses="text-blog" title={blogdetail.title} />
              <div dangerouslySetInnerHTML={{__html: blogdetail.text }}>
              {blogdetail.text}
              </div> */}
              <TextBlock title={t("moreBlogs")} />
              <div className="blogGrid">
                <div className="blogGrid-blogRow">
                  {blogs.map((blog, i) => this.renderBlog(blog, i))}
                </div>
              </div>
            </div>
          </main>
        )}
      </I18n>,
    ];
  }
}
export default withRouter(BlogSingle);



// WEBPACK FOOTER //
// ./src/Pages/BlogSingle.jsx